import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { ODOO_ONE_PAGER_URL } from '../content/odooPartnership';

const OdooOnePagerPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAF8] flex flex-col">
      <header className="sticky top-0 z-50 bg-[#FAFAF8]/95 backdrop-blur border-b border-[#E4EFD8]">
        <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
          <Link
            to="/odoo"
            className="inline-flex items-center gap-2 text-sm font-medium text-[#3B6D11] hover:text-[#27500A]"
          >
            <ArrowLeft className="h-4 w-4" />
            Partnership overview
          </Link>
          <a
            href={ODOO_ONE_PAGER_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-medium text-gray-600 hover:text-[#3B6D11] shrink-0"
          >
            Open in new tab
          </a>
        </div>
      </header>

      <iframe
        title="Kolanut × Odoo partnership summary"
        src={ODOO_ONE_PAGER_URL}
        className="flex-1 w-full min-h-[calc(100vh-3.5rem)] border-0 bg-white"
      />
    </div>
  );
};

export default OdooOnePagerPage;
